/* Reserved image slots for New In Stock Games. No cards are appended. */
(function () {
  'use strict';
  if (window.TgsCollectionCLS) { window.TgsCollectionCLS.scan(); return; }
  var media = window.matchMedia('(max-width: 798px)');
  var grids = new Map();
  var pendingSort = null;
  var sortWrapped = false;

  function unveilBatch(grid, index) {
    if (!media.matches || !grid.isConnected) return;
    var batch = Math.max(1, Number(grid.getAttribute('data-tgs-cls-batch')) || 12);
    var first = Math.floor(index / batch) * batch;
    grid.querySelectorAll('[data-tgs-cls-index]').forEach(function (card) {
      var i = Number(card.getAttribute('data-tgs-cls-index'));
      if (i < first || i >= first + batch) return;
      card.querySelectorAll('img.tgs-cls-image-pending').forEach(function (img) {
        img.classList.remove('tgs-cls-image-pending');
        img.classList.add('lazyload');
        if (window.lazySizes) window.lazySizes.loader.unveil(img);
        else {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
        }
      });
    });
  }

  function connect(grid) {
    var state = grids.get(grid);
    if (state.observer) state.observer.disconnect();
    state.observer = null;
    if (!media.matches) return;
    if (!('IntersectionObserver' in window)) {
      grid.querySelectorAll('[data-tgs-cls-index]').forEach(function (card) {
        unveilBatch(grid, Number(card.getAttribute('data-tgs-cls-index')));
      });
      return;
    }
    state.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || !media.matches) return;
        unveilBatch(grid, Number(entry.target.getAttribute('data-tgs-cls-index')));
        state.observer.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    grid.querySelectorAll('[data-tgs-cls-index]').forEach(function (card) {
      if (card.querySelector('.tgs-cls-image-pending')) state.observer.observe(card);
    });
  }

  function imageError(event) {
    var img = event.target;
    if (!img.matches || !img.matches('img') || !img.closest('[data-tgs-cls-grid]')) return;
    var parent = img.closest('.image-element__wrap');
    if (!parent || parent.querySelector('.tgs-cls-retry')) return;
    img.classList.add('tgs-cls-image-error');
    parent.classList.add('tgs-cls-retry-parent');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tgs-cls-retry';
    button.textContent = '\u21bb';
    button.setAttribute('aria-label', 'Retry image');
    button.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      button.remove();
      img.classList.remove('tgs-cls-image-error', 'lazyerror', 'lazyloaded');
      // Clear the failed request and let the existing lazy loader retry in place.
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      img.classList.add('lazyload');
      if (window.lazySizes) window.lazySizes.loader.unveil(img);
      else {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
      }
    });
    parent.appendChild(button);
  }

  function wrapSorting() {
    if (sortWrapped || !window.jQuery || !window.Shopify || !Shopify.theme || !Shopify.theme.jsCollection) return;
    var collection = Shopify.theme.jsCollection;
    var update = collection.updateView;
    if (typeof update !== 'function') return;
    collection.updateView = function () {
      if (pendingSort && pendingSort.readyState !== 4) pendingSort.abort();
      var originalAjax = window.jQuery.ajax;
      window.jQuery.ajax = function (options) {
        var safe = window.jQuery.extend({}, options);
        var onError = safe.error;
        safe.error = function (xhr, status) {
          if (status === 'abort') return;
          if (onError) return onError.apply(this, arguments);
        };
        pendingSort = originalAjax.call(this, safe);
        return pendingSort;
      };
      try { return update.apply(this, arguments); }
      finally { window.jQuery.ajax = originalAjax; }
    };
    sortWrapped = true;
  }

  function scan() {
    grids.forEach(function (state, grid) {
      if (!grid.isConnected) {
        if (state.observer) state.observer.disconnect();
        grids.delete(grid);
      }
    });
    document.querySelectorAll('[data-tgs-cls-grid]').forEach(function (grid) {
      if (grids.has(grid)) return;
      grids.set(grid, { observer: null });
      grid.addEventListener('error', imageError, true);
      connect(grid);
    });
    wrapSorting();
  }
  window.TgsCollectionCLS = { scan: scan };
  function start() {
    scan();
    var section = document.getElementById('shopify-section-collection__main');
    if (section) new MutationObserver(scan).observe(section, { childList: true, subtree: true });
    media.addEventListener('change', function () { grids.forEach(function (_, grid) { connect(grid); }); });
    // The theme sorts with pushState; reload restores the selected query on Back/Forward.
    window.addEventListener('popstate', function () { window.location.reload(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
